module.exports = __webpack_public_path__ + "images/help_v2/avatars/snow-8e3f18183fbae698b861c90ac645179c.png";